import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/bf-design-system.css';
import './styles/bf-extras.css';
import './styles/bf-chat-overrides.css';

(function applyBfThemeEarly() {
  try {
    const raw = localStorage.getItem('bf-theme');
    const theme = raw === 'dark' ? 'dark' : 'light';
    if (raw !== 'light' && raw !== 'dark') {
      localStorage.setItem('bf-theme', 'light');
    }
    document.documentElement.setAttribute('data-bf-theme', theme);
  } catch {
    document.documentElement.setAttribute('data-bf-theme', 'light');
  }
})();

ReactDOM.createRoot(document.getElementById('root')).render(<App />);





